module.exports = __webpack_public_path__ + "img/650.ddd03208.png";